import { forwardRef, type InputHTMLAttributes } from "react"
import BaseTextInput, { type TextInputProps } from "./TextInput"

type EmailInputProps = Omit<TextInputProps, "type" | "inputMode" | "pattern"> & {
  placeholder?: string
}

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
  ({ placeholder = "you@example.com", ...props }, ref) => {
    const inputProps: InputHTMLAttributes<HTMLInputElement> = {
      type: "email",
      inputMode: "email",
      autoComplete: "email",
      spellCheck: false,
      placeholder,
    }

    return <BaseTextInput ref={ref} {...inputProps} {...props} />
  },
)

EmailInput.displayName = "EmailInput"

export default EmailInput
